import { useQuery } from "react-query";
import Angie from "~/utils/angie";
import { fetch } from "~/utils/fetch";

export const useAccessLogs = (objectType, objectId, config) => {
  const slug = Angie.functions.slug(objectType);
  return useQuery({
    ...config,
    queryKey: ["access-logs", slug, objectId],
    queryFn: ({ signal }) =>
      fetch({
        url: `${Angie.api_url}/access-logs/${slug}/${objectId}`,
        signal,
      }),
  });
};
